<template v-slot>
  <div>
    <div class="content-video" v-if="publicity.type == 'video'">
      <iframe :src="publicity.video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>  
    </div>
    <div class="content-image" v-else>
      <img :src="publicity.image" alt="Imagem da publicidade" class="img-fluid">
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  export default {
    publicity: null,
    props: {
        publicity: {
            required: true
        }
    },
  }
</script>

<style lang="scss"> 
.content-video{
  width: 100%;
  height: 647px;
  margin-bottom: 0;
  @media screen and (max-width: 772px){
    height: 500px;
  }
  @media screen and (max-width: 576px){
    height: 410px;
  }
  iframe{
    width: 100%;
    height: 100%;
    @media screen and (max-width: 576px){
      height: 400px;
    }
  }
}
.content-image img{
  width: 100%;
  height: auto;
}
</style>